import VueRouter from "vue-router";

import ClemIndex from '@/pages/ClemIndex';
import ClemBlog from '@/pages/ClemBlog';
import ClemContact from '@/pages/ClemContact';
import CoreTeamList from "@/pages/CoreTeamList";
const router =new VueRouter({


    routes: [

        {
            // 主页路由
            name: 'index',
            path: '/',
            component: ClemIndex,
            meta: {title:'Clementine'}
        },
        {
            // 博客路由
            name: 'blog',
            path: '/clemblog',
            component: ClemBlog,
            meta: {title:'博客'}
        },
        {
            // 联系我们路由
            name: 'contact',
            path: '/clemcontact',
            component: ClemContact,
            meta: {title:'联系'}
        },
        {
            // 联系我们路由
            name: 'coreteamlist',
            path: '/coreteamlist',
            component: CoreTeamList,
            meta: {title:'核心团队'}
        }

    ]

});

// 全局后置路由守卫————初始化的时候被调用、每次路由切换之后被调用
router.afterEach((to, from)=>{
    document.title = to.meta.title || 'Clementine' //有title我就用 没有 就 ||或
})

export default router;
